var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Button } from "@components/ui";
import { PROPERTY_SHIPPING_COUNTRY, PROPERTY_SHIPPING_PLACE, PROPERTY_SHIPPING_SLOT, PROPERTY_SHIPPING_TYPE, PROPERTY_SHIPPING_ZIP_CODE } from "@constants/index";
import { useConfig } from "@context/config";
import { useStore } from "@context/store";
import { DeliveryType } from "@schema/types";
var AddToCart = function () {
    var _a = useStore(), timeEntry = _a.timeEntry, location = _a.location, type = _a.type;
    var _b = useConfig(), variantSelectorId = _b.variantSelectorId, country = _b.country;
    var variantSelector = useRef();
    var variantHasValue = function (value) {
        if (!variantSelector.current) {
            throw new Error("daap: Variant selector is not configured");
        }
        for (var i = 0; i < variantSelector.current.length; i++) {
            if (variantSelector.current.options[i].value == value) {
                return true;
            }
        }
        return false;
    };
    var selectVariant = function (variantId) {
        var newVariantId = "" + variantId;
        try {
            if (!variantSelector.current) {
                if (!variantSelectorId) {
                    throw new Error("daap: `variantSelectorId` is required");
                }
                variantSelector.current = document.getElementById(variantSelectorId);
                if (!variantSelector.current) {
                    throw new Error("daap: Cannot query variant selector by id " + variantSelectorId);
                }
                if (!variantHasValue(newVariantId)) {
                    throw new Error("daap: Variant selector does not have the variant id " + newVariantId + ". Are products properly configured?");
                }
            }
        }
        catch (e) {
            console.error(e);
            return;
        }
        variantSelector.current.value = newVariantId;
        var changeEvent = document.createEvent("HTMLEvents");
        changeEvent.initEvent("change", false, true);
        variantSelector.current.dispatchEvent(changeEvent);
    };
    useEffect(function () {
        if (type !== null && location && timeEntry) {
            selectVariant(timeEntry.variantId);
        }
    }, [type, location, timeEntry]);
    return (_jsxs(_Fragment, { children: [type !== null && location && timeEntry && (_jsxs(_Fragment, { children: [_jsx("input", { type: "hidden", name: PROPERTY_SHIPPING_TYPE, value: type }, void 0),
                    _jsx("input", { type: "hidden", name: PROPERTY_SHIPPING_PLACE, value: "" + location.id }, void 0),
                    _jsx("input", { type: "hidden", name: PROPERTY_SHIPPING_SLOT, value: "" + timeEntry.id }, void 0),
                    _jsx("input", { type: "hidden", name: PROPERTY_SHIPPING_COUNTRY, value: "" + country }, void 0),
                    _jsx("input", { type: "hidden", name: PROPERTY_SHIPPING_ZIP_CODE, value: type === DeliveryType.Doorstep
                            ? "" + location
                                .zipCode
                            : "" }, void 0)] }, void 0)),
            _jsx(Button, __assign({ rounded: true, primary: true, disabled: !(type !== null && location && timeEntry), type: "submit" }, { children: "Add to cart" }), void 0)] }, void 0));
};
export default AddToCart;
